import React, { PropsWithChildren, useContext } from 'react'
import { Controller } from 'react-hook-form'
import { FieldContext } from '../constants'
import { FieldControllerContext } from '../stores/context'
import { FieldInputControllerProps } from '../types/Field.types'
import { FieldInput } from './FieldInput'

export const FieldAutocompleteController: React.FC<PropsWithChildren<FieldInputControllerProps>> = ({
  controller,
  errors,
  children
}) => {
  const { name, ...fieldContextProps } = useContext(FieldContext)

  const fieldControllerContextValue = { errors }

  return (
    <FieldControllerContext.Provider value={fieldControllerContextValue}>
      <Controller
        name={name || ''}
        control={controller}
        render={({ field: { name, onChange, ...rest }, fieldState }) => {
          const fieldError = fieldState.invalid
          const fieldHelperText = errors?.[name]?.message

          const handleChange = (_: React.SyntheticEvent<Element, Event>, value: unknown) => {
            onChange(value)
          }

          return (
            <FieldInput fieldError={fieldError} fieldHelperText={fieldHelperText} onChange={handleChange} {...rest}>
              {children}
            </FieldInput>
          )
        }}
      />
    </FieldControllerContext.Provider>
  )
}
